import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import Loader from '../common/Loader';

const AuthRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, authInitialized, hasGroupAccess } = useAuth();
  const [processedAuth, setProcessedAuth] = useState(false);
  
  // Wait for auth to stabilize before redirecting
  useEffect(() => {
    if (!isLoading && authInitialized && !processedAuth) {
      console.log("[AUTH-REDIRECT] Auth state stable:", { isAuthenticated, hasGroupAccess });
      
      const redirectTimer = setTimeout(() => {
        if (isAuthenticated && hasGroupAccess) {
          console.log("[AUTH-REDIRECT] Authenticated with group access, redirecting to dashboard");
          navigate('/dashboard', { replace: true });
        } else {
          console.log("[AUTH-REDIRECT] Not authenticated or no group access, redirecting to login");
          navigate('/login', { replace: true });
        }
        setProcessedAuth(true);
      }, 300);
      
      return () => clearTimeout(redirectTimer);
    }
  }, [isAuthenticated, isLoading, authInitialized, hasGroupAccess, navigate, processedAuth]);
  
  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center' 
    }}>
      <h2 style={{ marginBottom: '1rem' }}>Verarbeite Anmeldung</h2>
      <Loader />
      <p style={{ color: '#666', marginTop: '1rem' }}>Sie werden automatisch weitergeleitet...</p>
      
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <small style={{ color: '#666' }}>
          Status: 
          {isLoading ? " Lädt..." : " Bereit"} • 
          {authInitialized ? " Auth initialisiert" : " Auth wird initialisiert"} • 
          {isAuthenticated ? " Angemeldet" : " Nicht angemeldet"} •
          {hasGroupAccess ? " Gruppenberechtigung OK" : " Gruppenberechtigung wird geprüft"} •
          {processedAuth ? " Verarbeitet" : " Wird verarbeitet"}
        </small>
      </div>
    </div>
  );
};

export default AuthRedirect;